"use strict";
exports.tagIds = {
    qualified: '23105287',
    unqualified: '23105351',
    hasCosigner: '23105479'
};
